<template>
  <div class="isu-grid">
    <button
      type="button"
      v-for="item in options"
      :key="item.id"
      class="isu-pill"
      :class="{ active: isSelected(item.id) }"
      @click="toggle(item.id)"
    >
      {{ item.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: "IsuSelector",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    isSelected(id) {
      return this.value.includes(id)
    },
    toggle(id) {
      let newValue = []

      if (this.isSelected(id)) {
        newValue = this.value.filter(x => x !== id)
      } else {
        newValue = [...this.value, id]
      }

      this.$emit("input", newValue)
    }
  }
}
</script>

<style scoped>
.isu-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
}

.isu-pill {
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid #d1d1d1;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: 0.15s ease;
  white-space: nowrap;
}

.isu-pill.active {
  background: #f6f6ff;
  border-color: #262298;
  color: #262298;
  box-shadow: 0 0 0 2px rgba(38, 34, 152, 0.2);
}

.isu-pill:hover {
  background: #f6f6ff;
}

@media (max-width: 640px) {
  .isu-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
